import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsideLook } from './components/InsideLook';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wj8g1vvmd07v">
      <MetaPixel data-id="element-1" data-mp="2wi5qbra193tj" />
      <CountdownBar data-id="element-2" data-mp="28u5uwe1s0p8m" />
      <main data-id="element-3" data-mp="28te0v7ntuzkg">
        <Hero data-id="element-4" data-mp="28t4ju9krg2qw" />
        <StatsBar data-id="element-5" data-mp="28sl48zil1qg1" />
        <Difference data-id="element-6" data-mp="28s2zfehuu3wi" />
        <Recognize data-id="element-7" data-mp="23vktwcepa1j4" />
        <WhatsInside data-id="element-8" data-mp="23w4c7u89irxo" />
        <InsideLook data-id="element-9" data-mp="23utby4e102bb" />
        <Bonuses data-id="element-10" data-mp="23t8gmcjw0fce" />
        <Offer data-id="element-11" data-mp="3ijxokogyjwiu" />
        <Guarantee data-id="element-12" data-mp="3ikha0f5th31m" />
        <Testimonials data-id="element-13" data-mp="3iiwfuqnezm4a" />
        <Faq data-id="element-14" data-mp="3ijpbavgxap74" />
      </main>
      <Footer data-id="element-15" data-mp="3ii4ppvcl6gle" />
    </div>;
}